var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-horizontal',[_c('router-view'),_c('app-navbar-horizontal-layout-brand'),_c('navbar',{attrs:{"toggle-vertical-menu-active":_vm.toggleVerticalMenuActive}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }